import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {from} from 'rxjs';
import {map} from 'rxjs/operators';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ProjectService, ProjectTypeService, TranslationService, UserService} from '../../services';
import {FormUtil} from '../../utils';
import {ProjectType} from "../../models/project-analysis";

@Component({
    selector: 'app-create-project-modal',
    templateUrl: './create-project-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateProjectModalComponent {
    private projectService = inject(ProjectService);
    private userService = inject(UserService);
    public modalRef = inject(VwuiModalRef);
    private translationService = inject(TranslationService);
    private projectTypeService = inject(ProjectTypeService);

    public form = new UntypedFormGroup({
        name: new UntypedFormControl('', Validators.required),
        address: new UntypedFormControl('', Validators.required),
        city: new UntypedFormControl('', Validators.required),
        country: new UntypedFormControl('NL', Validators.required),
        companyName: new UntypedFormControl('', Validators.required),
        projectTypeId: new UntypedFormControl('', Validators.required),
    });
    public loading = false;
    public countries: {id: string; name: string}[];
    public readonly projectTypes = toSignal(this.projectTypeService.list(), {initialValue: [] as ProjectType[]});
    public readonly companyNames = toSignal(
        from(this.userService.getUserInfo()).pipe(
            map((userInfo) => userInfo.getCompanyNamesForManuallyAddingProjects())
        ),
        {initialValue: [] as string[]}
    );

    constructor() {
        const translationService = this.translationService;

        this.countries = translationService.getCountriesAsKeyValue();
    }

    async submit() {
        this.loading = true;

        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                await this.projectService.createProject(this.form.value);
                this.modalRef.close(true);
            }
        } finally {
            this.loading = false;
        }
    }
}
